import type { SvgIconComponent } from '@mui/icons-material';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import HealthAndSafetyOutlinedIcon from '@mui/icons-material/HealthAndSafetyOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import RecyclingOutlinedIcon from '@mui/icons-material/RecyclingOutlined';
import Co2OutlinedIcon from '@mui/icons-material/Co2Outlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';

const KNOWLEDGE_ARTICLE_ICONS: Record<string, SvgIconComponent> = {
  dashboard: DashboardOutlinedIcon,
  'dashboard-overview': DashboardOutlinedIcon,
  'dashboard-widget-customization': TuneOutlinedIcon,
  'esg-reports': AssessmentOutlinedIcon,
  'report-general-esg': AssessmentOutlinedIcon,
  'report-waste-circularity': RecyclingOutlinedIcon,
  'report-carbon-avoidance': Co2OutlinedIcon,
  'data-source': EditNoteOutlinedIcon,
  'data-source-intro': EditNoteOutlinedIcon,
  'utility-data-entry': BoltOutlinedIcon,
  'utility-proofs': AttachFileOutlinedIcon,
  'data-source-settings': SettingsOutlinedIcon,
  'employee-training': SchoolOutlinedIcon,
  'employee-training-overview': SchoolOutlinedIcon,
  'record-training-session': PostAddOutlinedIcon,
  'employee-training-detail': PersonOutlinedIcon,
  'training-categories': CategoryOutlinedIcon,
  'health-safety': HealthAndSafetyOutlinedIcon,
  'hse-weekly-report': CalendarMonthOutlinedIcon,
  'hse-terms': InfoOutlinedIcon,
  notifications: NotificationsOutlinedIcon,
  'notification-bell': NotificationsOutlinedIcon,
  'mark-notifications-read': MarkEmailReadOutlinedIcon,
};

export const getKnowledgeArticleIcon = (articleId: string): SvgIconComponent =>
  KNOWLEDGE_ARTICLE_ICONS[articleId] ?? MenuBookOutlinedIcon;
